export function validateName( name?: string ): boolean
{
	if( !name )
	{
		return false
	}

	if( name.length > 75 )
	{
		return false
	}

	return true
}

export function validateEmail( email?: string ): boolean
{
	if( !email )
	{
		return false
	}

    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

export function validateSubject( subject?: string ): boolean
{
	if( !subject )
	{
		return false
	}

	if( subject.length > 100 )
	{
		return false
	}

	return true
}

export function validateMessage( message?: string ): boolean
{
	if( !message )
	{
		return false
	}

	if( message.length > 100 )
	{
		return false
	}

	return true
}